/**
 * NorbiPhone – KÖZPONTI BRAND DESIGN TOKENEK  (single source of truth)
 * ============================================================================
 * A NorbiPhone Brand Guide az EGYETLEN vizuális referencia. Minden márkaszín
 * innen érkezik – se a React app (NorbiPhone.hu), se a landing, se az admin nem
 * használ hardcode-olt márka-hexet.
 *
 * FONTOS – a #22C55E NEM brand szín, hanem kizárólag SUCCESS állapot
 * (sikeres mentés/beküldés/beváltás, státusz-badge). A márka zöldje: #39B54A.
 *
 * Felhasználás:
 *   - Tailwind:  frontend/tailwind.config.js  require('./src/theme/designTokens')
 *                → osztályok: bg-brand, text-brand, hover:bg-brand-hover,
 *                  bg-brand-light, border-border, bg-success, text-danger …
 *   - JS/JSX:    import { colors } from '../theme/designTokens'
 *   - Statikus landing (nincs build): landing/index.html :root CSS-változói
 *     UGYANEZEKET az értékeket tükrözik (kézzel szinkronban tartva).
 *
 * CommonJS (module.exports), hogy a tailwind.config.js require-elni tudja; a
 * JSX ESM-import (`import { colors } from …`) a babel-interopon át működik.
 */

const colors = {
  // ── MÁRKA ────────────────────────────────────────────────────────────────
  brand: '#22833A',        // Primary Green – CTA, logo, hero, kiemelés, heading, brand badge (WCAG AA: 4,80:1 fehéren)
  brandHover: '#1C6E2E',   // Primary Hover (sötétebb, AA)
  brandLight: '#EAF8EC',   // Primary Light – halvány márka-háttér / tint
  brandGradient: { from: '#8FEC78', to: '#81DD67' }, // hero/gomb világoszöld gradiens

  // ── SEMLEGES ─────────────────────────────────────────────────────────────
  black: '#111111',        // Black – fő szöveg, sötét CTA
  white: '#FFFFFF',
  darkText: '#333333',     // Dark Text – másodlagos szöveg
  lightGray: '#F5F5F5',    // Light Gray – halvány szekció-háttér
  border: '#E5E7EB',       // Border

  // ── ÁLLAPOT (NEM márka) ──────────────────────────────────────────────────
  success: '#22C55E',      // Success – CSAK sikeres állapot / státusz badge
  warning: '#F59E0B',
  danger: '#EF4444',

  // ── CSATORNA ─────────────────────────────────────────────────────────────
  // Messenger Blue. A régi #0084FF fehér szöveggel csak 3,66:1 → NEM felel meg a
  // WCAG AA-nak (15px normál szöveghez 4,5:1 kell). A #0866FF a Meta JELENLEGI
  // hivatalos Messenger-kékje ÉS 4,82:1 – márkahű és megfelelő.
  messenger: { DEFAULT: '#0866FF', hover: '#0653D6' },
};

const typography = {
  fontFamily:
    "system-ui,-apple-system,BlinkMacSystemFont,'Segoe UI','Roboto','Oxygen','Ubuntu','Cantarell','Fira Sans','Droid Sans','Helvetica Neue',sans-serif",
  monoFamily: "source-code-pro,Menlo,Monaco,Consolas,'Courier New',monospace",
  size: {
    h1: '3rem',      // ~text-5xl
    h2: '2.25rem',   // ~text-4xl
    h3: '1.5rem',    // ~text-2xl
    body: '1rem',    // text-base
    small: '0.875rem', // text-sm
    xs: '0.75rem',   // text-xs
  },
  weight: { normal: 400, medium: 500, semibold: 600, bold: 700, extrabold: 800 },
  leading: { tight: 1.1, snug: 1.3, normal: 1.5 },
};

// 4px-alapú skála (Tailwind-kompatibilis)
const spacing = {
  xs: '8px', sm: '12px', md: '16px', lg: '24px', xl: '32px', '2xl': '48px', section: '80px',
};

const radius = {
  sm: '8px',      // rounded-lg
  btn: '12px',    // gombok (rounded-xl)
  card: '16px',   // kártyák (rounded-2xl)
  lg: '24px',     // nagy elemek / hero kép (rounded-3xl)
  pill: '9999px', // pill / badge / kör
};

const shadow = {
  sm: '0 1px 2px rgba(20,30,22,.05),0 4px 14px -8px rgba(20,30,22,.14)',
  md: '0 1px 2px rgba(20,30,22,.04),0 10px 30px -14px rgba(20,30,22,.16)',
  lg: '0 20px 50px -20px rgba(20,30,22,.28)',
};

const transitions = {
  base: '.15s ease',   // ≈ Tailwind transition-colors (150ms)
  slow: '.3s ease',    // duration-300
};

const zIndex = {
  base: 1, dropdown: 100, sticky: 500, header: 900, overlay: 1000, modal: 1100,
  toast: 1200, consent: 9999,
};

const container = { maxWidth: '1120px' };

// Tailwind alap breakpointok (a projekt ezeket használja)
const breakpoints = { sm: '640px', md: '768px', lg: '1024px', xl: '1280px', '2xl': '1536px' };

const designTokens = {
  colors, typography, spacing, radius, shadow, transitions, zIndex, container, breakpoints,
};

module.exports = designTokens;
module.exports.colors = colors;
module.exports.typography = typography;
module.exports.spacing = spacing;
module.exports.radius = radius;
module.exports.shadow = shadow;
module.exports.transitions = transitions;
module.exports.zIndex = zIndex;
module.exports.container = container;
module.exports.breakpoints = breakpoints;
module.exports.designTokens = designTokens;
